import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { KindAllNodeStringStoreContext } from '../contexts/StoreContext'
import { KindAllNodeStringStore } from '../store/interface'

export const useKindAllNodeStringStore = <M extends boolean, StateSlice>(
  selector: (store: KindAllNodeStringStore<M>) => StateSlice
) => {
  return useContextStore<KindAllNodeStringStore<M>, StateSlice>(
    KindAllNodeStringStoreContext as any,
    selector
  )
}

export const useKindAllNodeStringStoreApi = <M extends boolean>() => {
  return useContextStoreApi<KindAllNodeStringStore<M>>(
    KindAllNodeStringStoreContext as any
  )
}
